import React, { useEffect, useState } from 'react';
import { useQuery, NetworkStatus } from '@apollo/client';
import { useAccountContext } from 'contexts/account';
import { LoadingModule } from 'components/loading';
import { ErrorContent } from 'components/errors';
import { CarouselButtons } from 'components/carousel-buttons';
import {
  SEARCH_PLANS,
  PLAN_PAGINATION_LIMIT,
  DashboardPlan,
} from '../dashboard.api';

interface ChildProps {
  plans: DashboardPlan[];
  showPagination: boolean;
}
interface Props {
  children: ({ plans, showPagination }: ChildProps) => React.ReactNode;
  status: 'active' | 'inactive';
  count: number;
}

export const PlansWrapper = ({ children, status, count }: Props) => {
  const { selectedAccountId } = useAccountContext();
  const [page, setPage] = useState(0);
  const {
    data,
    loading: searchPlanLoading,
    error,
    refetch,
    networkStatus,
  } = useQuery<SearchPlansQuery, SearchPlansQueryVariables>(SEARCH_PLANS, {
    variables: {
      accountId: selectedAccountId,
      page: page + 1,
      statuses: [status],
    },
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    refetch();
  }, [count]);

  if (searchPlanLoading || networkStatus === NetworkStatus.refetch) {
    return <LoadingModule variant="list" padding="16px" />;
  }
  if (error || !data) {
    return <ErrorContent />;
  }
  const { plans } = data.search.plans;

  if (!count) return null;
  const showPagination = count > PLAN_PAGINATION_LIMIT;

  return (
    <>
      {children({ plans: [...plans], showPagination })}
      {showPagination && (
        <CarouselButtons
          index={page}
          setIndex={setPage}
          itemName="page"
          length={Math.ceil(count / PLAN_PAGINATION_LIMIT)}
        />
      )}
    </>
  );
};
